var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from 'react';

var MarkerLockbeat = function MarkerLockbeat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 47",
    ref: svgRef
  }, props), React.createElement("title", null, title), React.createElement("defs", null, React.createElement("path", {
    id: "MarkerLockbeat_a",
    d: "M315 1830c-3.31 0-6 1.12-6 2.5s2.69 2.5 6 2.5 6-1.12 6-2.5-2.69-2.5-6-2.5z"
  }), React.createElement("path", {
    id: "MarkerLockbeat_b",
    d: "M315 1788c-8.3 0-15 6.89-15 15.4 0 11.55 15 28.6 15 28.6s15-17.05 15-28.6c0-8.51-6.7-15.4-15-15.4"
  }), React.createElement("path", {
    id: "MarkerLockbeat_c",
    d: "M310.43 1802.9c-.79 0-1.43.64-1.43 1.43v6.24c0 .79.64 1.43 1.43 1.43H319c.79 0 1.43-.64 1.43-1.43v-6.24c0-.79-.64-1.43-1.43-1.43zm4.28 5.7a1.6 1.6 0 0 1-1.6-1.6c0-.88.72-1.6 1.6-1.6.88 0 1.6.72 1.6 1.6 0 .88-.72 1.6-1.6 1.6z"
  }), React.createElement("path", {
    id: "MarkerLockbeat_d",
    d: "M312.5 1802.1v-1.53a2.22 2.22 0 0 1 4.43 0v1.53h1.35v-1.53a3.57 3.57 0 0 0-7.14 0v1.53z"
  })), React.createElement("use", {
    fill: "#6f7070",
    xlinkHref: "#MarkerLockbeat_a",
    opacity: 0.4,
    transform: "translate(-300 -1788)"
  }), React.createElement("use", {
    fill: "#53b3e3",
    xlinkHref: "#MarkerLockbeat_b",
    transform: "translate(-300 -1788)"
  }), React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#MarkerLockbeat_c",
    transform: "translate(-300 -1788)"
  }), React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#MarkerLockbeat_d",
    transform: "translate(-300 -1788)"
  }));
};

export default MarkerLockbeat;